import { registerComponent, registerSystem } from "aframe";
import { InputComponent, InputSystem, inputSystemSchema, press, release } from "./common";
import { MouseInputSystem } from "./mouse";


const specialKeys : { [key:string] : string } =
{
	" " : "Space",
	"Escape" : "Esc",
	"ArrowUp" : "Up", "ArrowLeft" : "Left", "ArrowDown" : "Down", "ArrowRight" : "Right",
}

const convertKey = (key : string) =>
{
	const special = specialKeys[key];
	if(special) return special;
	if(key.startsWith("Key") && (key.length == 4)) return key.slice(3).toLowerCase();
	if(key.startsWith("Digit") && (key.length == 6)) return key.slice(5);
	return key;
}

registerSystem("keyboard", { 
	schema : inputSystemSchema,
	init(this : InputSystem)
	{
		this.isPrimaryInput = true;

		const handleGamepad = (event : GamepadEvent) => {
			this.isPrimaryInput = (event.type == "gamepaddisconnected");
			this.el.emit("primary-input-changed", this);
		};
		window.addEventListener("gamepadconnected", handleGamepad);
		window.addEventListener("gamepaddisconnected", handleGamepad);

		this.layout = JSON.parse( localStorage.getItem("keyboard-layout") || "{}" );

		const learnLayout = (reason : any) =>
		{
			reason && console.warn("Failed to retrieve keyboard layout", reason);
			window.addEventListener("keydown", (event : KeyboardEvent) =>
			{
				const code = convertKey(event.code);
				if(this.layout![code] == event.key)
					return;
				this.layout![code] = event.key;
				localStorage.setItem("keyboard-layout", JSON.stringify(this.layout));
			});
		}

		const kb = (navigator as any).keyboard;
		if(kb && kb.getLayoutMap)
			kb.getLayoutMap().then( 
				(kblm : any) =>
				{
					const entries = Array.from<string[]>(kblm.entries());	
					for(let entry of entries)
						this.layout![ convertKey(entry[0]) ] = entry[1];
					learnLayout(null);
				},
				learnLayout );
		else //Learn keyboard layout through events :
			learnLayout("Browser does not support Keyboard Layout API");
	}
} );

registerComponent("keyboard", {
	init(this : InputComponent)
	{
		const scene = this.el.sceneEl!;
		this.actions = {};

		const mouseSystem = scene.systems.mouse as MouseInputSystem;

		//Keyboard is linked to mouse : use the same ray.
		const getRay = (origin:any, direction:any, setter:Function) => mouseSystem.getRay(origin, direction, setter);

		const keydown = (e : KeyboardEvent) =>
		{
			if(e.repeat) return;
			const key = convertKey(e.code);
			const action = this.system.data[ key ];
			return action && press(this, action, key, 1.0, getRay) && e.preventDefault();
		};
		const keyup = (e : KeyboardEvent) =>
		{
			const key = convertKey(e.code);
			const action = this.system.data[ key ];
			return action && release(this, action, key) && e.preventDefault();
		};
		scene.canvas.addEventListener("keydown", keydown as EventListener);
		scene.canvas.addEventListener("keyup", keyup as EventListener);


		//
		window.addEventListener("blur", () =>
		{
			for(let action in this.actions)
			{
				for(let key in this.actions[action].keys)
					release(this, action, key);
			}
		});

		//TODO : remove listeners ?
	},
	feedback(this : InputComponent, intensity : number) {}
} );


